import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {ConfigProvider} from 'antd';
import en_US from 'antd/es/locale/en_US';
import zh_CN from 'antd/es/locale/zh_CN';
import {withTranslation} from 'react-i18next';
import scrollToElement from 'scroll-to-element';
import {withRouter} from 'react-router';
import moment from 'moment';
import 'moment/locale/zh-cn';

class Application extends React.PureComponent {
  constructor(props) {
    super(props);
    this.resolveLocale = this.resolveLocale.bind(this);
  }

  componentDidMount() {
    this.scrollToHash();
    this.updateAntArrows();
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.location) !== JSON.stringify(this.props.location)) {
      this.scrollToHash();
      this.updateAntArrows();
    }
  }

  scrollToHash() {
    const hash = this.props.location.hash;
    if (hash) {
      scrollToElement(hash, {offset: -120});
    }
  }

  updateAntArrows() {
    // I did not know how else could I swap all the ant arrows, time was rushing
    Array.from(document.getElementsByClassName('ant-select-arrow-icon')).forEach(element => {
      element.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="7.414" viewBox="0 0 12.414 7.414">
    <defs>
        <style>
            .cls-1{fill:none;stroke:currentColor;stroke-width:2px}
        </style>
    </defs>
    <g transform="rotate(90 5.5 6.207)">
        <path id="Line_1" d="M0 0l6 6" class="cls-1" data-name="Line 1"/>
        <path id="Line_3" d="M0 6l6-6" class="cls-1" data-name="Line 3" transform="translate(0 5)"/>
    </g>
</svg>
`;
    });
  }

  resolveLocale() {
    switch (this.props.i18n.language) {
      case 'zh': {
        moment.locale('zh_cn');
        return zh_CN;
      }
      default: {
        moment.locale('en');
        return en_US;
      }
    }
  }

  render() {
    return (
      <ConfigProvider locale={this.resolveLocale()}>
        {this.props.children}
      </ConfigProvider>
    );
  }
}

Application.propTypes = {
  children: PropTypes.any,
  i18n: PropTypes.shape({
    language: PropTypes.string.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    hash: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(connect()(withTranslation()(Application)));



// WEBPACK FOOTER //
// /src/Application.jsx